
import styled from "styled-components";
import { useRef } from "react";
import {
  GoogleMap,
  MarkerClusterer,
} from "@react-google-maps/api";
import { useDispatch } from "react-redux";
import { showModal, showNestedModal } from "../../features/modal/modalSlice";
import {
  getShipmentDriverLocationsById,
  resetAllState,
  setIsActiveSide,
  setRemainingDistance,
  setTopPagesMapTamamlananShipmentItemCurrentLocationData,
} from "../../features/topPagesMap/topPagesMapSlice";
import avatar from "../../images/img/avatar.jpg";
import { getSingleShipmentLoadItem } from "../../features/loadList/loadListSlice";
import { useSelector } from "react-redux";
import MemoizedOverlayDriverLocation from "./overlays/MemoizedOverlayDriverLocation";
import { setSelectUserData } from "../../features/user/userSlice";
import getPastDateAndTime from "../../helper/date/getPastDateAndTime";
import { useEffect } from "react";

const Container = styled.div`
  width: 100%;
  height: 600px;
  display: flex;

  .map-side-container {
    width: 230px;
    height: 100%;
    background-color: var(--color-main);
    color: #fff;

    .side-top-container {
      border-bottom: 1px solid #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 25px 20px;

      .top-data-container {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .top-data-name {
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
        }

        .top-data-phone {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
        }
      }

      .top-img-container {
        width: 70px;
        height: 70px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover !important;
        }
      }
    }

    .side-mid-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 30px;
      padding: 25px 20px;
      margin-bottom: auto;

      .side-mid-item {
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
      }
    }

    .side-bottom-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 25px 20px;
      border-top: 1px solid #fff;

      button {
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-xl);
        padding: 5px 15px;
        border-radius: 5px;
        border: 1px solid #fff;
      }
    }
  }
`;


const TopPagesMapTamamlanan = () => {
  const dispatch = useDispatch();
  const { singleShipmentLoadItem } = useSelector((state) => state.loadList);
  const { isActiveSide, topPagesMapTamamlananShipmentItemCurrentLocationData, topPagesMapAllTamamlananShipmentCurrentLocationList } = useSelector((state) => state.topPagesMap);

  const initialCenterRef = useRef({ lat: 39.419221, lng: 34.343262 });

    useEffect(()=> {

      return () => {
          dispatch(resetAllState())
       }

     },[])

  return (
    <Container>
      <GoogleMap
        center={initialCenterRef.current}
        zoom={6}
        mapContainerStyle={{
          height: "100%",
          width: isActiveSide ? `calc(100% - 230px)` : "100%",
        }}
      >
      

      {/* {singleShipmentLoadItem?.id && 
        <Marker
          position={{ lat: parseFloat(singleShipmentLoadItem.routePoints.$values[singleShipmentLoadItem.routePoints.$values.length-1].lat), lng: parseFloat(singleShipmentLoadItem.routePoints.$values[singleShipmentLoadItem.routePoints.$values.length-1].lng) }}
          icon={{
            url: bayrakk,
            anchor: new window.google.maps.Point(0, 32),
            size: new window.google.maps.Size(20, 32),
            origin: new window.google.maps.Point(0, 0),
          }}
        />
      } */}

        {/* <Polygon
          paths={polygonCoords}
          options={{
            fillColor: "lightblue",
            fillOpacity: 0.4,
            strokeColor: "blue",
            strokeOpacity: 1,
            strokeWeight: 2,
          }}
        /> */}

        <MarkerClusterer averageCenter={true} gridSize={60}>
          {(clusterer) => (
            <>
              {topPagesMapAllTamamlananShipmentCurrentLocationList.map((item, i) => (
                <MemoizedOverlayDriverLocation
                  position={{
                    lat: parseFloat(item?.currentDriverLocation?.lat),
                    lng: parseFloat(item?.currentDriverLocation?.lng),
                  }}
                  isActive={topPagesMapTamamlananShipmentItemCurrentLocationData?.shipmentId === item?.shipmentId}
                  imageUrl={
                    item?.driverInfo?.profilePhoto
                      ? `${process.env.REACT_APP_API_IMG_URI}${item?.driverInfo?.profilePhoto}`
                      : avatar
                  }
                  itemId={item.shipmentId}
                  animationControlType={"animate"}
                  handleClick={() => {
                    // dispatch(getPastKonumItemId(item.shipmentId));
                    dispatch(getSingleShipmentLoadItem(item.shipmentId));
                    dispatch(setIsActiveSide(true));
                    dispatch(setTopPagesMapTamamlananShipmentItemCurrentLocationData(item.shipmentId))
                  }}
                />
              ))}
            </>
          )}
        </MarkerClusterer>

      
      </GoogleMap>
      {isActiveSide && (
        <div className="map-side-container">
          {singleShipmentLoadItem ? (
            <>
              <div className="side-top-container">
                <div className="top-data-container">
                  <span
                    className="top-data-name"
                    onClick={() => {
                      dispatch(
                        setSelectUserData(
                          singleShipmentLoadItem.driverPhoneNumber
                        )
                      );
                      dispatch(showNestedModal("surucuProfil"));
                    }}
                  >
                    {singleShipmentLoadItem.driverName}
                  </span>
                  <span className="top-data-phone">
                    {singleShipmentLoadItem.driverPhoneNumber}
                  </span>
                </div>
                <div
                  className="top-img-container"
                  onClick={() => {
                    dispatch(
                      setSelectUserData(
                        singleShipmentLoadItem.driverPhoneNumber
                      )
                    );
                    dispatch(showNestedModal("surucuProfil"));
                  }}
                >
                  <img
                    src={
                      singleShipmentLoadItem.userProfilePhoto
                        ? `https://egeyurtgrupbucket.s3.eu-north-1.amazonaws.com/Images/${singleShipmentLoadItem.userProfilePhoto} `
                        : avatar
                    }
                    alt="Profile photo"
                  />
                </div>
              </div>
              <div className="side-mid-container">
                <div className="side-mid-item">
                  Nereden:{" "}
                  {singleShipmentLoadItem?.routePoints?.$values[0]?.city} - {" "}
                  {singleShipmentLoadItem?.routePoints?.$values[0]?.town}
                </div>
                <div className="side-mid-item">
                  Nereye:{" "}
                  {
                    singleShipmentLoadItem?.routePoints?.$values[
                      singleShipmentLoadItem?.routePoints?.$values?.length - 1
                    ]?.city
                  }
                  -{" "}
                  {
                    singleShipmentLoadItem?.routePoints?.$values[
                      singleShipmentLoadItem?.routePoints?.$values?.length - 1
                    ]?.town
                  }
                </div>
                <div className="side-mid-item">
                  Plaka:{" "}
                  {singleShipmentLoadItem?.waitinLoad?.aspiredLoads?.$values[0]?.truckPlateNumber || singleShipmentLoadItem?.truckPlateNumber || singleShipmentLoadItem?.trailerPlateNumber || singleShipmentLoadItem?.waitinLoad?.aspiredLoads?.$values[0]?.trailerPlateNumber ||  "---"}

                </div>
                <div className="side-mid-item">
                   Sefer Bitiş Tarihi: 
                  {getPastDateAndTime(singleShipmentLoadItem.routePoints.$values[singleShipmentLoadItem.routePoints.$values.length-1].routePointEndDate).formattedDate} - {getPastDateAndTime(singleShipmentLoadItem.routePoints.$values[singleShipmentLoadItem.routePoints.$values.length-1].routePointEndDate).formattedTime} 
                </div>
              </div>

              <div className="side-bottom-container">
                <button onClick={() => {dispatch(showModal("topPagesTamamlananWideMap")); dispatch(getShipmentDriverLocationsById({fromWhere: "tamamlanan", shipmentId: singleShipmentLoadItem.id}))}}>
                  Detaylı Görünüm
                </button>
              </div>
            </>
          ) : (
            <div></div>
          )}
        </div>

      )}
    </Container>
  );
};

export default TopPagesMapTamamlanan;